import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "bitwise"
})
export class BitwisePipe implements PipeTransform {
	transform(
		value: any,
		type:
			| "AND"
			| "OR"
			| "XOR"
			| "left-shift"
			| "right-shift"
			| "right-shift-discard",
		otherValue: any
	): number {
		switch (type) {
			case "AND":
				return value & otherValue;
			case "OR":
				return value | otherValue;
			case "XOR":
				return value ^ otherValue;
			case "left-shift":
				return value << otherValue;
			case "right-shift":
				return value >> otherValue;
			case "right-shift-discard":
				return value >>> otherValue;
			default:
				return value;
		}
	}
}
